export default __webpack_public_path__ + "content/media/IcoWhatsapp.d14b7002.svg";